import { hookstate } from "@hookstate/core";

export const ShowRateModalState = hookstate(false);
